import { type Locale, getLanguageFromLocale } from '@seek/melways-sites';

import { useJobQuery } from 'src/graphql/__generated__';

import { useConfig } from './useConfig';

export const useQueryJob = (jobId: string) => {
  const { locale } = useConfig();
  const language = getLanguageFromLocale(locale as Locale);

  const { loading, error, data } = useJobQuery({
    fetchPolicy: 'no-cache',
    variables: {
      input: {
        jobId,
        language,
      },
    },
  });

  return {
    loading,
    error,
    data,
  };
};
